/* Lifestyle Gallery HH — fade-in + lightbox */
(function(){
  'use strict';

  function initFadeIn(){
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.hh-gallery__item').forEach(el => el.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const idx = Array.from(entry.target.parentElement.children).indexOf(entry.target);
          entry.target.style.transitionDelay = (idx % 6) * 50 + 'ms';
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -30px 0px' });
    document.querySelectorAll('.hh-gallery__item').forEach(el => io.observe(el));
  }

  class HHLightbox {
    constructor(gallery){
      this.gallery = gallery;
      this.items = Array.from(gallery.querySelectorAll('.hh-gallery__item[data-lightbox]'));
      if (this.items.length === 0) return;
      this.images = this.items.map(it => ({
        src: it.dataset.fullSrc || it.querySelector('img')?.src,
        alt: it.querySelector('img')?.alt || ''
      }));
      this.current = 0;
      this.build();
      this.bind();
    }

    build(){
      const html = `
        <div class="hh-gallery-lightbox" role="dialog" aria-modal="true" aria-label="معرض الصور">
          <button class="hh-gallery-lightbox__close" type="button" aria-label="إغلاق">
            <svg viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          </button>
          ${this.images.length > 1 ? `
          <button class="hh-gallery-lightbox__nav hh-gallery-lightbox__nav--prev" type="button" aria-label="السابق">
            <svg viewBox="0 0 24 24" fill="none"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
          <button class="hh-gallery-lightbox__nav hh-gallery-lightbox__nav--next" type="button" aria-label="التالي">
            <svg viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
          <div class="hh-gallery-lightbox__counter"></div>
          ` : ''}
          <img class="hh-gallery-lightbox__img" src="" alt="">
        </div>
      `;
      const wrapper = document.createElement('div');
      wrapper.innerHTML = html;
      this.lightbox = wrapper.firstElementChild;
      document.body.appendChild(this.lightbox);
      this.img = this.lightbox.querySelector('.hh-gallery-lightbox__img');
      this.counter = this.lightbox.querySelector('.hh-gallery-lightbox__counter');
      this.closeBtn = this.lightbox.querySelector('.hh-gallery-lightbox__close');
      this.prevBtn = this.lightbox.querySelector('.hh-gallery-lightbox__nav--prev');
      this.nextBtn = this.lightbox.querySelector('.hh-gallery-lightbox__nav--next');
      this.isRTL = getComputedStyle(this.gallery).direction === 'rtl';
    }

    bind(){
      this.items.forEach((item, idx) => {
        item.addEventListener('click', (e) => {
          // If it's a link, don't intercept
          if (item.tagName === 'A' && item.getAttribute('href') && item.getAttribute('href') !== '#') return;
          e.preventDefault();
          this.open(idx);
        });
      });
      this.closeBtn?.addEventListener('click', () => this.close());
      this.lightbox.addEventListener('click', (e) => {
        if (e.target === this.lightbox) this.close();
      });
      this.prevBtn?.addEventListener('click', () => this.go(this.isRTL ? 1 : -1));
      this.nextBtn?.addEventListener('click', () => this.go(this.isRTL ? -1 : 1));
      document.addEventListener('keydown', (e) => {
        if (!this.lightbox.classList.contains('is-open')) return;
        if (e.key === 'Escape') this.close();
        else if (e.key === 'ArrowLeft') this.go(this.isRTL ? 1 : -1);
        else if (e.key === 'ArrowRight') this.go(this.isRTL ? -1 : 1);
      });
    }

    open(idx){
      this.current = idx;
      this.update();
      this.lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    close(){
      this.lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    go(dir){
      this.current = (this.current + dir + this.images.length) % this.images.length;
      this.update();
    }
    update(){
      const data = this.images[this.current];
      this.img.src = data.src;
      this.img.alt = data.alt;
      if (this.counter) this.counter.textContent = `${this.current + 1} / ${this.images.length}`;
    }
  }

  function initLightboxes(){
    document.querySelectorAll('.hh-gallery[data-lightbox-enabled="true"]').forEach(gallery => {
      if (gallery.__hhLightbox) return;
      gallery.__hhLightbox = new HHLightbox(gallery);
    });
  }

  function init(){
    initFadeIn();
    initLightboxes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
